import isIOS from '../os/ios';
import __regexp from './__safari-regexp';
import { matchVersion } from '../../utils';
/** Detect Apple Safari Browser version */
export default function isSafariVersion(operator, version) {
	return function (ua) {
		return (
			matchVersion({
				ua: ua,
				version: version,
				operator: operator,
				regExp: __regexp,
				groupIndex: 1
			}) && !isIOS(ua)
		);
	};
}
